import { render, staticRenderFns } from "./OpenDateManageView.vue?vue&type=template&id=53c0833e&scoped=true&"
import script from "./OpenDateManageView.vue?vue&type=script&lang=js&"
export * from "./OpenDateManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0833e",
  null
  
)

export default component.exports